import {
  FetchUISettingsRequest,
  FetchUISettingsSuccess,
  FetchUISettingsFailure,
  UpdateUISettingsRequest,
  UpdateUISettingsSuccess,
  UpdateUISettingsFailure,
} from './ui-settings.actions'
import { UISettingsService } from './ui-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as UISettingsTypes from './ui-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class UISettingsEffects {
  constructor(
    private actions: Actions,
    private UISettingsService: UISettingsService,
  ) {}

  FetchUISettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(UISettingsTypes.FETCH_UI_SETTINGS_REQUEST),
      switchMap((action: FetchUISettingsRequest) => {
        return this.UISettingsService.fetchUISettings().pipe(
          map((result) => {
            return new FetchUISettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchUISettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateUISettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(UISettingsTypes.UPDATE_UI_SETTINGS_REQUEST),
      switchMap((action: UpdateUISettingsRequest) => {
        return this.UISettingsService.updateUISettings(action.payload).pipe(
          switchMap((result) => {
            return [new UpdateUISettingsSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateUISettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
